"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var useStoreContext_1 = require("./useStoreContext");
var useStoreMutation = function () {
    var store = useStoreContext_1.default().store;
    return {
        put: store.put,
    };
};
exports.default = useStoreMutation;
//# sourceMappingURL=useStoreMutation.js.map